<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row">
  <div class="col wccard py-3">
    <div class="row mb-2">
      <div class="col">
        <p class="f-14 mb-3 font-weight-500 mb-3 d-flex justify-content-between pointer">Call log <span class="text-blue"><a data-testid="auto-app-call-log-settings-a-1" class="text-blue"
              (click)="openCalllogModal()">+ ADD NEW</a></span></p>
        <p class="mb-3  f-14 gray-text">Below list of outcomes will appear as options while logging a call against a candidate.</p>
      </div>
    </div>
    <p class="gray-text font-weight-500">Outcomes</p>

    <div class="accordion" id="canFilterAccordian1">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button data-testid="auto-app-call-log-settings-button-1" class="btn btn-link px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
              aria-expanded="false" aria-controls="collapseOne">
              <span class="f-14"> Positive Outcomes</span>
              <span class="wcAccordianUpDownArrow">
                <span class="test1"><i class="far fa-angle-up"></i></span>
                <span class="test2"> <i class="far fa-angle-down"></i></span>
              </span>
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#canFilterAccordian1">
          <div class="card-body pt-0">
            <div class="row locationHover mt-2" *ngFor="let outcome of positiveOutcome, let i = index">
              <div class="col d-flex py-3 pointer">
                <div class="position-relative w-100">
                  <div class="d-flex align-items-center">
                    {{outcome.outcometext}}
                  </div>
                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="editCallLogModal(outcome)">
                      <i class="fas fa-edit"></i>
                    </span>
                    <span class="mx-1 ats-cta-btn pointer" *ngIf="positiveOutcome.length>1" (click)="openDeleteConfirmationModal(outcome)">
                      <i class="fas fa-trash-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button data-testid="auto-app-call-log-settings-button-2" class="btn btn-link px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
              aria-expanded="false" aria-controls="collapseTwo">
              <span class="f-14"> Negative Outcomes</span>
              <span class="wcAccordianUpDownArrow">
                <span class="test1"><i class="far fa-angle-up"></i></span>
                <span class="test2"> <i class="far fa-angle-down"></i></span>
              </span>
            </button>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#canFilterAccordian1">
          <div class="card-body pt-0">
            <div class="row locationHover mt-2" *ngFor="let outcome of negativeOutcome, let i = index">
              <div class="col d-flex py-3 pointer">

                <div class="position-relative w-100">
                  <div class="d-flex align-items-center">
                    {{outcome.outcometext}}</div>

                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="editCallLogModal(outcome)">
                      <i class="fas fa-edit"></i>
                    </span>
                    <span class="mx-1 ats-cta-btn pointer" *ngIf="negativeOutcome.length>1" (click)="openDeleteConfirmationModal(outcome)">
                      <i class="fas fa-trash-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0">
            <button data-testid="auto-app-call-log-settings-button-3" class="btn btn-link px-0 collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              <span class="f-14"> Neutral Outcomes</span>
              <span class="wcAccordianUpDownArrow">
                <span class="test1"><i class="far fa-angle-up"></i></span>
                <span class="test2"> <i class="far fa-angle-down"></i></span>
              </span>
            </button>
          </h5>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#canFilterAccordian1">
          <div class="card-body pt-0">

            <div class="row locationHover mt-2" *ngFor="let outcome of neutralOutcome, let i = index">
              <div class="col d-flex py-3 pointer">

                <div class="position-relative w-100">
                  <div class="d-flex align-items-center">
                    {{outcome.outcometext}}</div>

                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="editCallLogModal(outcome)">
                      <i class="fas fa-edit"></i>
                    </span>
                    <!--  -->
                    <span class="mx-1 ats-cta-btn pointer" *ngIf="neutralOutcome.length>1" (click)="openDeleteConfirmationModal(outcome)">
                      <i class="fas fa-trash-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card"  *ngIf="positiveInactiveOutcome?.length>0 || negativeInactiveOutcome?.length>0 ||neutralInactiveOutcome?.length>0">
        <div class="card-header" id="headingFour">
          <h5 class="mb-0">
            <button data-testid="auto-app-call-log-settings-button-4" class="btn btn-link px-0 collapsed" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              <span class="f-14"> Archived Outcome</span>
              <span class="wcAccordianUpDownArrow">
                <span class="test1"><i class="far fa-angle-up"></i></span>
                <span class="test2"> <i class="far fa-angle-down"></i></span>
              </span>
            </button>
          </h5>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#canFilterAccordian1">
          <div class="card-body pt-0">
              <div class="row">
                  <div class="col bg-gray my-2">
            <p class="font-weight-600 text-black py-3 mt-2" *ngIf="positiveInactiveOutcome?.length>0">Positive
              Archived Declined Reasons</p>
              </div>
              </div>
            <div class="row locationHover" *ngFor="let outcome of positiveInactiveOutcome, let i = index">
              <div class="col d-flex py-3 pointer">

                <div class="position-relative w-100">
                  <div class="d-flex align-items-center" title="positive outcome">
                    {{outcome.outcometext}}
                  </div>

                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="openRedoConfirmationModal(outcome)">
                      <i class="fas fa-redo-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col bg-gray my-2">
                  <p class="font-weight-600 text-black py-3 mt-2" *ngIf="negativeInactiveOutcome?.length>0">Negative
                      Archived Declined Reasons</p>
              </div>
            </div>
            <div class="row locationHover" *ngFor="let outcome of negativeInactiveOutcome, let i = index">
              <div class="col d-flex py-3 pointer">

                <div class="position-relative w-100">
                  <div class="d-flex align-items-center" title="Negative outcome">
                    {{outcome.outcometext}}
                  </div>

                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="openRedoConfirmationModal(outcome)">
                      <i class="fas fa-redo-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col bg-gray my-2">
            <p class="font-weight-600 text-black py-3 mt-2" *ngIf="neutralInactiveOutcome?.length>0">Neutral
                Archived Declined Reasons</p>
                </div>
            </div>
            <div class="row locationHover" *ngFor="let outcome of neutralInactiveOutcome, let i = index">
              <div class="col d-flex py-3 pointer">

                <div class="position-relative w-100">
                  <div class="d-flex align-items-center" title="neutral outcome">
                    {{outcome.outcometext}}
                  </div>

                  <div class="position-absolute tr0">
                    <span class="mx-2 ats-cta-btn pointer" (click)="openRedoConfirmationModal(outcome)">
                      <i class="fas fa-redo-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<ng-template #delete class="modal reloginmodal">
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="createTalentTitle"></h5>
    <button data-testid="auto-app-call-log-settings-button-5" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-6">
    <div class="row mb-6">
      <div class="col text-center pb-3">
        <p>{{delete_confirmaton}}
          <p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-10 mx-auto d-flex">
        <button data-testid="auto-app-call-log-settings-button-6" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-call-log-settings-button-7" class="btn-trms-small m-auto" (click)="deleteCallLogOutcome()">YES</button>
      </div>

    </div>
  </div>
</ng-template>

<ng-template #redo class="modal reloginmodal">
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="createTalentTitle"></h5>
    <button data-testid="auto-app-call-log-settings-button-8" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-6">
    <div class="row mb-6">
      <div class="col text-center pb-3">
        <p>{{delete_confirmaton}}
          <p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-10 mx-auto d-flex">
        <button data-testid="auto-app-call-log-settings-button-9" class="btn-trms-white mx-auto" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-call-log-settings-button-10" class="btn-trms-small m-auto" (click)="redoCallLogOutcome()">YES</button>
      </div>

    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
    <span class="successCheck"><i class="fal fa-check"></i> </span>
   <span class="successmsg">{{ successMessage }}</span>
 </ngb-alert>

 <ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
   <span class="errorCheck"><i class="fal fa-times"></i></span>
   <span class="errormsg"> {{ errorMessage }} </span>
 </ngb-alert>
